// Helpers de validación de anchos de columna para secciones tipo 'table'.
// El motor low-code (PDF/TemplateEngine/sections/TableSection) aplica los
// `width` literalmente como estilo de @react-pdf. Si las columnas no suman
// 100%, queda un gap visual al costado. Por eso el editor bloquea el guardado
// hasta que la suma sea 100% (tolerancia 0.5% para absorber redondeos float).

export const WIDTH_SUM_TOLERANCE = 0.5;

export const parseWidthPct = (w) => {
  if (w == null) return 0;
  const n = parseFloat(w);
  return Number.isFinite(n) ? n : 0;
};

export const sumColumnWidths = (columns = [], computedColumns = []) => {
  const all = [...(columns || []), ...(computedColumns || [])];
  return all.reduce((sum, col) => sum + parseWidthPct(col?.width), 0);
};

export const isWidthSumValid = (sum) => Math.abs(sum - 100) <= WIDTH_SUM_TOLERANCE;

export const isTableSectionWidthsValid = (section) => {
  if (section?.type !== 'table') return true;
  const cols = section?.config?.columns || [];
  const comp = section?.config?.computedColumns || [];
  if (cols.length + comp.length === 0) return true;
  return isWidthSumValid(sumColumnWidths(cols, comp));
};

// Para feedback en el top-level Guardar: devuelve nombres de las secciones
// table cuya suma de widths es inválida. Usado por TemplateEditor.handleSave
// para mostrar qué secciones están rotas antes de persistir.
export const findInvalidTableSections = (sections = []) =>
  sections
    .filter((s) => s?.type === 'table' && !isTableSectionWidthsValid(s))
    .map((s) => s?.title || s?.id || 'Sin título');
